/** Hover-shadow affordance applied to editable (non-read-only) metric cards. */
export const METRIC_CARD_HOVER_CLASS = "shadow-md transition-shadow duration-200 hover:shadow-lg";
